import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Recover password validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export const recoverPasswordValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control.parent || !control) {
    return null;
  }

  const password = control.parent.get('password');
  const passwordConfirm = control.parent.get('confirm');

  if (!password || !passwordConfirm) {
    return null;
  }

  if (passwordConfirm.value === '') {
    return null;
  }

  if (password.value === passwordConfirm.value) {
    return null;
  }

  return { passwordsNotMatching: true };
};
